import * as React from "react";
import { ActionCardData } from "../types";
import Button from "./Button";
import StoreContainer from "../stores/StoreContainer";

interface Props {
  data: ActionCardData;
  onClick: (name: string, data: string) => void;
}

function ActionCard(props: Props) {
  const actions = [...props.data.Actions];

  //this feels dirty
  //It's here because if we're in a bot chat and
  //we're waiting on a calendly result wee need
  //a skip button so that they're not forced to book a meeting
  //Having it here is easier than appending it to the actual ActionCard
  //and having to remove it later
  if (StoreContainer.BotStore.getCalendlyResult()) {
    actions.push({
      Name: "calendly_skip",
      Label: "Skip",
      Data: null
    });
  }

  return (
    <div className="action-card">
      <div className="action-card-image">
        <img alt="card" src={props.data.ImageUrl} />
      </div>
      <div className="action-card-text">
        <h3>{props.data.Title}</h3>
        <p>{props.data.Message}</p>
      </div>
      <div className="action-card-actions">
        {actions.map((action, i) => (
          <Button
            key={i}
            className="action-card-button"
            variant="primary"
            onClick={() => {
              props.onClick(action.Name, action.Data);
            }}
          >
            {action.Label}
          </Button>
        ))}
      </div>
    </div>
  );
}

export default ActionCard;
